/* Header presentation only; Shopify's automatic discount is configured separately.
   Unpublished/development themes show a fresh demo clock for design review. */
(() => {
  const selector = '[data-steadia-offer]';
  const memory = new Map();

  function storedDeadline(key, duration) {
    const now = Date.now();
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        const storage = window[name];
        const saved = Number(storage.getItem(key));
        if (Number.isFinite(saved) && saved > 0) return saved;
        const deadline = memory.get(key) || now + duration;
        storage.setItem(key, String(deadline));
        memory.set(key, deadline);
        return deadline;
      } catch (_) {
        // A blocked primary store can fall back to this tab's session store.
      }
    }
    // Without persistent storage, do not claim a time-limited offer.
    return null;
  }

  function initialise(root) {
    if (root.dataset.offerInitialised) return;
    root.dataset.offerInitialised = 'true';
    const clock = root.querySelector('[data-offer-clock]');
    const label = root.querySelector('[data-offer-label]');
    if (!clock || !label) return;
    const minutes = Number(root.dataset.offerMinutes);
    const duration = (Number.isFinite(minutes) && minutes > 0 ? minutes : 60) * 60000;
    const key = root.dataset.offerKey || 'steadia:bundle-window:v1';
    const themeRole = window.Shopify?.theme?.role;
    const preview = themeRole === 'unpublished' || themeRole === 'development';
    let deadline = preview ? Date.now() + duration : storedDeadline(key, duration);
    if (preview) root.dataset.offerPreview = 'true';
    let interval;
    const expire = () => {
      clock.hidden = true;
      label.hidden = true;
      root.dataset.offerExpired = 'true';
      clearInterval(interval);
    };
    const tick = () => {
      const remaining = deadline === null ? 0 : Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      if (!remaining) {
        expire();
        return;
      }
      const values = { hours: Math.floor(remaining / 3600), minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      Object.entries(values).forEach(([unit, value]) => {
        root.querySelector(`[data-offer-${unit}]`).textContent = String(value).padStart(2, '0');
      });
      root.dataset.offerDeadline = String(deadline);
      clock.setAttribute('aria-label', `${values.hours} hours, ${values.minutes} minutes, ${values.seconds} seconds remaining`);
    };
    tick();
    if (root.dataset.offerExpired !== 'true') interval = setInterval(tick, 1000);
    const resume = () => {
      if (root.isConnected) tick();
      else clearInterval(interval);
    };
    window.addEventListener('pageshow', resume);
    document.addEventListener('visibilitychange', resume);
    window.addEventListener('storage', event => {
      if (preview || event.key !== key || !event.newValue) return;
      const other = Number(event.newValue);
      if (Number.isFinite(other) && other > 0 && (deadline === null || other < deadline)) {
        deadline = other;
        resume();
      }
    });
  }

  document.querySelectorAll(selector).forEach(initialise);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll(selector).forEach(initialise);
  });
})();
